import { useTranslation } from "react-i18next";
import { getRejectedReceivedRequestsFilter } from "../../../../../common/queries";
import EntityTable from "../../../../common/tables/EntityTable";
import useMissionRequestsColumns from "../../../../../hooks/useMissionRequestsColumns";
import { useStation } from "../../../../../providers/StationProvider";
import { useMemo } from "react";

export default function RejectedRequestsSection(props) {
  const { onRowClick } = props;
  const { t } = useTranslation();

  const columns = useMissionRequestsColumns(false, null, null, false, true);
  const { station } = useStation();
  const filter = useMemo(() => getRejectedReceivedRequestsFilter(station), [station]);


  return !!station ? (
    <EntityTable
      tableId="rejected_requests_section"
      type="MissionRequest"
      onRowClick={onRowClick}
      columns={columns}
      filter={filter}
      serverSidePaging
      emptyStateTitle={t("missionRequests:rejectedRequestsSection:emptyStateTitle")}
      emptyStateDescription={t("missionRequests:rejectedRequestsSection:emptyStateDescription")}
      sortDescendingByDefault
      xs={12}
    />
  ) : null;
}
